import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { Baseproperties } from "src/app/views/utility/baseproperties";

@Injectable({ providedIn: 'root' })
export class Verticalservice{
    constructor(private httpClient: HttpClient,private route:Router){}
    baseproperties: Baseproperties = new Baseproperties(); 
    private baseURL = this.baseproperties.gatewayBaseURL+'/common/vertical'; 
    add(payload: any): Observable<Object> {
        return this.httpClient.post(`${this.baseURL}/createvertical`, payload);  // audit Add
      }
      modify(payload: any): Observable<Object> {
        return this.httpClient.post(`${this.baseURL}/updatevertical`, payload);  // audit update
      }
      getall_list(): Observable<any> {
        return this.httpClient.get(`${this.baseURL}/getall`);
      }
      getDataView_byId(id: String): Observable<any> {
        return this.httpClient.get(`${this.baseURL}/findvertical/${id}`);
      }
      verticalDataExcel()
      {
         return this.httpClient.get(`${this.baseURL}/verticaldataexcel`,{ responseType: 'blob' }); 
      }

      inactivateVertical(payload: any): Observable<Object> {
        return this.httpClient.post(`${this.baseURL}/inactivatevertical`, payload);
      }

      getConfiguration(): Observable<any[]> {
      return this.httpClient.get<any[]>(`${this.baseURL}/getconfiguration`);
    }
}